import React from "react";
import {Link} from "react-router";

import {OrganisationId} from "common/types/organisation";
import {LlmRunScore} from "common/flowmaster/types/llm_run";

type Props = {
  organisationId: OrganisationId;
  unscoredRuns: LlmRunScore[];
};

export default function UnscoredRuns({organisationId, unscoredRuns}: Props) {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>batch id</th>
            <th>llm run id</th>
            <th>doc id</th>
            <th>state</th>
          </tr>
        </thead>
        <tbody>
          {unscoredRuns.map(runScore => (
            <tr key={runScore.llm_run_id}>
              <td>{runScore.batch_id}</td>
              <td>
                <Link
                  to={`/organisation/${organisationId}/llm_run/${runScore.llm_run_id}/detail`}
                >
                  {runScore.llm_run_id}
                </Link>
              </td>
              <td>{runScore.document_issue_id}</td>
              <td>{JSON.stringify(runScore.problem_complexity_pass_state)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
